<div
  class="sub-header"
>
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        @if (!(isContractReadOnly$ | async)) {
          <app-actions />
        }
      </div>
    </div>
  </div>
</div>
